<div mat-dialog-content class="pb-12" ngClass.gt-xs='w-520'>
    <div class="modal-header font-size-18 text-bold artstuff-orange-fg">{{data.title}}</div>
    <div class="font-size-14 mt-20" [innerHTML]="data.content"></div>
</div>
<div class="w-100-p text-center">
    <button mat-stroked-button (click)="dialogRef.close(false)"
        class="artstuff-orange-fg cursor-pointer text-uppercase w-120 mt-12 h-36">
        {{ 'GUIDELINE_DOCUMENT_DIALOG.CLOSE' | translate }}
    </button>
</div>